import React from 'react';
import { Route } from '../Routing/types';
import { NutritionDietType, NutritionSummary } from '@front-activerse/modules';

const dummy_t = (translationKey: string) => translationKey;

const descendantRoutes: Route[] = [
  {
    path: '/diet-type',
    private: false,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <NutritionDietType />,
  },
  {
    path: '/summary',
    private: false,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <NutritionSummary />,
  },
];

export default descendantRoutes;
